/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import LocationSelectorFilter from '../LocationSelector';

const FlightTypeFilter = React.forwardRef((props, receivedRef) => {
  const ownRef = useRef();
  const ref = receivedRef || ownRef;
  const { translate } = React.useContext(Context);
  const { options, isDirty, setWasClear } = props;
  const locationSelectorFilterRef = useRef();
  const flightTypeOptions = React.useMemo(() => {
    return (Array.isArray(options) ? options : []).map((option) => ({
      ...option,
      label: translate(`cmp-journey-type-options-${option.label}`)
    }));
  }, [options, translate]);

  return (
    <LocationSelectorFilter
      {...props}
      options={flightTypeOptions}
      dataTestId="flightTypeFilter"
      placeholder={translate('cmp-flight-type-placeholder', 'Select Flight Type')}
      inputFocusReferences={ref ?? locationSelectorFilterRef}
      onBlur={() => {
        if (isDirty) {
          setWasClear(false);
        }
      }}
      allowVariableHighlightedIndex={true}
    />
  );
});

FlightTypeFilter.defaultProps = {
  icon: 'flight-type',
  options: [
    { label: 'rt', value: 'ROUND_TRIP' },
    { label: 'ow', value: 'ONE_WAY' },
    { label: 'ew', value: 'EACH_WAY' }
  ],
  showSelectorMenuArrow: false,
  openOnFocus: true,
  showLabelInside: false,
  clearable: false,
  selectMode: true,
  showCode: false,
  showArrowsIfClearable: false,
  menuItem: {
    shadow: '4',
    paddingHeight: '0',
    rounded: '0',
    border: true
  },
  inputItem: {
    shadow: '@theme:input.shadow',
    rounded: '@theme:input.rounded'
  },
  listItem: {
    hoverBgColor: 'primary',
    hoverTextColor: 'white',
    paddingLeft: '4',
    paddingRight: '1',
    paddingHeight: '2'
  },
  groupItem: {
    hoverBgColor: 'primary',
    hoverTextColor: 'white',
    paddingWidth: '1',
    paddingHeight: '2'
  },
  noResultItem: {
    paddingWidth: '1',
    paddingHeight: '2'
  }
};

export default FlightTypeFilter;
